<template>
  <div ref="detail">
    <div v-if="currentNotice"
         class="notice-detail">
      <BreadcrumbBack :navs="navs"></BreadcrumbBack>
      <div class="content">
        <div class="title">{{ currentNotice.title }}</div>
        <div class="update-time">
          <span>更新时间:{{ currentNotice.last_time || currentNotice.add_time }}</span>
        </div>
        <el-divider></el-divider>
        <div style="line-height: 24px;" v-html="currentNotice.info"></div>
      </div>
    </div>

  </div>
</template>

<script>
  import apis from "@/api/apis";
  import BreadcrumbBack from '@/tools/BreadcrumbBack'
  import {Loading} from 'element-ui';

  export default {
    name: 'noticeDetail',
    components: {BreadcrumbBack},
    data() {
      return {
        loadingInstance: null,
        currentNotice: null,
      }
    },
    computed: {
      navs() {
        return [
          {
            title: '公告列表',
          },
          {
            title: '详情',
          },
        ]
      },
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        const id = this.$route.params.id
        if (!id) {
          return
        }
        this.loadingInstance = Loading.service({
          target: this.$refs.detail,
          customClass: 'loading'
        })
        this.getNoticeDetail(id)

      },
      getNoticeDetail(id) {
        apis.notice.noticeDetail({id}).then(res => {
          this.currentNotice = res.data
          document.getElementById('title').innerHTML = this.currentNotice.title + ' - 微客云集'
          this.loadingInstance.close()
        })
      },
    },
  }
</script>
<style scoped lang="scss">
  ::v-deep.loading{
    margin-top: 100px;
  }
  .list-detail {
    min-height: 100%;
    position: relative;

    .page {
      padding: 20px 5px;
      text-align: right;
      width: 100%;
      position: absolute;
      bottom: 0;
    }
  }

  .notice-list {
    .notice {
      padding: 20px 0;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:hover {
        color: #0B4FFC;
      }

      .notice-title {
        width: 752px;
        margin-right: 40px;
        font-size: 16px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);

      }

      .time {
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 20px;
      }
    }
  }

  .content {
    .title {
      font-size: 32px;
      font-weight: 500;
      color: #1E1E28;
      line-height: 30px;
      text-align: left;
      margin-top: 32px;
    }

    .update-time {
      font-size: 14px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 20px;
      margin-top: 8px;
      margin-bottom: 24px;
    }
  }

</style>
